import React, { useState, useEffect } from "react";
import styles from "./galeria_robin_tattooart.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes, FaArrowUp } from "react-icons/fa";

// Import das imagens
import Gal1 from './src/galeria/gal1.jpeg';
import Gal2 from './src/galeria/gal2.jpeg';
import Gal3 from './src/galeria/gal3.jpeg';
import Gal4 from './src/galeria/gal4.jpeg';
import Gal5 from './src/galeria/gal5.jpeg';
import Gal6 from './src/galeria/gal6.jpeg';

const Galeria_robin_tattooart: React.FC = () => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showScrollTop, setShowScrollTop] = useState(false);

    const imagens = [Gal1, Gal2, Gal3, Gal4, Gal5, Gal6];

    const openLightbox = (index: number) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);
    const prevImage = () =>
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    const nextImage = () =>
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className={styles.galeria_robin_tattooart}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/robin_tattooart" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Galeria</h1>
            </div>

            {/* CONTEÚDO - Galeria */}
            <div className={styles.content}>
                <div className={styles.galleryGrid}>
                    {imagens.map((img, index) => (
                        <div
                            key={index}
                            className={styles.imageContainer}
                            onClick={() => openLightbox(index)}
                        >
                            <img src={img} alt={`Galeria ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {lightboxOpen && (
                <div className={styles.lightbox}>
                    <button className={styles.closeBtn} onClick={closeLightbox}>
                        <FaTimes />
                    </button>
                    <button className={styles.prevBtn} onClick={prevImage}>
                        <FaChevronLeft />
                    </button>
                    <img
                        src={imagens[currentIndex]}
                        alt={`Galeria ${currentIndex + 1}`}
                        className={styles.lightboxImage}
                    />
                    <button className={styles.nextBtn} onClick={nextImage}>
                        <FaChevronRight />
                    </button>
                </div>
            )}

            {/* BOTÃO FLUTUANTE */}
            {showScrollTop && (
                <button className={styles.scrollTopButton} onClick={scrollToTop}>
                    <FaArrowUp />
                </button>
            )}

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a
                        href="https://wa.me/5516992524152?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <WhatsappIcon height="30" color="#ffffff" />
                            </div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/NLuVHyzeQn2xU44a8" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <MapsIcon height="30" color="#ffffff" />
                            </div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a
                        href="https://www.instagram.com/robin_tattooart?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <InstagramIcon height="26" color="#ffffff" />
                            </div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Galeria_robin_tattooart;
